import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Zap, Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) nav("/");
    else setError(res.error);
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] grid place-items-center px-4 py-10">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2 justify-center mb-6">
          <div className="h-10 w-10 rounded-xl bg-[#00E5FF] grid place-items-center cyan-glow">
            <Zap className="h-5 w-5 text-[#0B0F17]" strokeWidth={2.5} />
          </div>
          <span className="font-heading font-extrabold text-xl text-white">
            Aurum<span className="text-[#00E5FF]">PropsAI</span>
          </span>
        </div>
        <div className="rounded-2xl border border-[#233248] bg-[#141C2B] p-6">
          <h1 className="font-heading text-xl font-bold text-white mb-1">Welcome back</h1>
          <p className="text-sm text-slate-400 mb-5">Sign in to save your slips and AI picks.</p>
          <form onSubmit={submit} className="space-y-3">
            <input
              data-testid="login-email-input"
              type="email"
              required
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full rounded-lg bg-[#0B0F17] border border-[#233248] px-3 py-2.5 text-white text-sm outline-none focus:border-[#00E5FF]"
            />
            <input
              data-testid="login-password-input"
              type="password"
              required
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full rounded-lg bg-[#0B0F17] border border-[#233248] px-3 py-2.5 text-white text-sm outline-none focus:border-[#00E5FF]"
            />
            {error && <p className="text-sm text-[#EF4444]" data-testid="login-error">{error}</p>}
            <button
              data-testid="login-submit-button"
              type="submit"
              disabled={loading}
              className="w-full flex items-center justify-center gap-2 rounded-lg bg-[#00E5FF] text-[#0B0F17] font-semibold py-2.5 hover:bg-[#33EaFF] disabled:opacity-60"
            >
              {loading && <Loader2 className="h-4 w-4 animate-spin" />} Sign In
            </button>
          </form>
          <p className="text-sm text-slate-400 mt-4 text-center">
            No account?{" "}
            <Link to="/register" data-testid="go-register-link" className="text-[#00E5FF] font-medium">
              Create one
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
